function Divider({ my }: { my?: string | number }) {
  return <div className={`h-[1px] bg-[#d5d5d5] w-full ${my ?? "my-2"}`}></div>;
}

export default Divider;
